const features = [
  {
    icon: 'ri-leaf-line',
    title: 'Premium Tea Leaves',
    description:
      'We source only the finest tea leaves from Afghanistan and Kashmir, hand-selected for quality and freshness.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Authentic Taste',
    description:
      'Every brew follows time-honored recipes passed down through generations, ensuring genuine flavor in every cup.',
  },
  {
    icon: 'ri-time-line',
    title: 'Fresh Preparation',
    description:
      'We brew each cup to order using fresh ingredients. No pre-made batches — just pure, freshly crafted chai.',
  },
  {
    icon: 'ri-home-smile-line',
    title: 'Relaxing Atmosphere',
    description:
      'Our tea house is designed as a sanctuary — warm lighting, comfortable seating, and a calm ambiance.',
  },
  {
    icon: 'ri-gift-line',
    title: 'Quality Packaging',
    description:
      'Our green tea packs are sealed to lock in freshness and aroma, presented in elegant, gift-worthy packaging.',
  },
  {
    icon: 'ri-heart-3-line',
    title: 'Made with Love',
    description:
      'Every cup, every paratha, every interaction is infused with genuine care and hospitality.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
            Why Ghalib Chai
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            What Makes Us Special
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base">
            From the quality of our ingredients to the warmth of our service,
            we believe in creating moments worth savoring.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}